import { Injectable } from '@angular/core';
import acrisCodesJson from '../../../assets/data/acrisCodes.json';
import { AcrisCodes, CarType, CarCategory } from './car-detail';

// see origin:
// http://www.acriss.org/expanded-matrix.asp

@Injectable({
  providedIn: 'root'
})
export class AcrisCarCodesService {

  constructor() {
    this.acrisCodes = <AcrisCodes>(<Object>acrisCodesJson);
    this.typeValues = Object.values(this.acrisCodes.types);
    this.categoryValues = Object.values(this.acrisCodes.categories);
  }

  private acrisCodes: AcrisCodes;
  private typeValues: Array<CarType>;
  private categoryValues: Array<CarCategory>;

  public get categories() {
    return this.acrisCodes.categories;
  }

  public get types() {
    return this.acrisCodes.types;
  }

  public getCarTypeByCode(code: any): CarType {
    return this.typeValues
      .find(v => v.code === code);
  }

  public getCategoryByCode(code: any): CarCategory {
    return this.categoryValues
      .find(v => v.code === code);
  }

}
